var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilament(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -1 14 24",
    width: 48,
    height: 48,
    "aria-label": "Dob\\xF3r materia\\u0142\\xF3w",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#52d552",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.2v3.8a1.8 1.8 0 0 0 1.8 1.8h4.4A1.8 1.8 0 0 0 16 16v-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v1.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilament);
export default __webpack_public_path__ + "static/media/filament.db9ecc26460fb6c467563f0990dfa735.svg";
export { ForwardRef as ReactComponent };